import { createEffect } from 'effector'

const slidesByLocation: Record<string, Record<string, number>> = Object.create(
  null
)

export const saveBannerSlideFx = createEffect(
  ({
    locationKey,
    bannerId,
    slide,
  }: {
    locationKey: string
    bannerId: string
    slide: number
  }) => {
    if (!slidesByLocation[locationKey]) {
      slidesByLocation[locationKey] = Object.create(null)
    }
    slidesByLocation[locationKey][bannerId] = slide
  }
)

export const clearBannerSlidesFx = createEffect((locationKey: string) => {
  delete slidesByLocation[locationKey]
})

export function getBannerSlide(
  locationKey: string,
  bannerId: string
): number | undefined {
  return slidesByLocation[locationKey]?.[bannerId]
}
